<template>
  <div class="container">
    <div class="row">
      <div class="col 2-col">
        <h2 id="summarystats">1. Summary Statistics</h2>
          <div v-if="this.factsheet.info.config.selected_options.includes('is_svi')">
            Due to limited relevance to the vanilla sector, the contents of this section have been omitted for the SVI commune-level reports.
          </div>
          <div v-else>
          <p>Use this map and the corresponding table to see thematic indicators for specific areas within your 
          landscape. The results are shown in the table, and depending on the indicator, it is possible to switch 
          units, for example between percentages and total area.</p>
        <IndicatorMap 
          backgrounds="streets,satellite,light,osm,landcover" 
          title="Summary Statistics" 
          attribution="Map: Geofolio Landscape Reports. Data: GFW/JRC. Backgrounds: Mapbox/Openstreetmap [13] Contributors/ESA WorldCover." 
          v-bind:location="location" 
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded" 
           >
        </IndicatorMap>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable */
    import IndicatorMap from '@/components/factsheet/ldr/maps/IndicatorMap.vue'

    export default {
        name: 'Quickscan',
        components: { IndicatorMap },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
              
            }
        },
        created() {
        },
        computed: {
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>